export const OPTIMOVE_SDK_ENABLED = '1';
